import 'css-chunksrc/client/scenes/chatbot/messages/styles.scss';export default {
  "scrollPane": "_scrollPane_88hr8_1",
  "messages": "_messages_88hr8_5",
  "placeholder": "_placeholder_88hr8_11",
  "statusMessage": "_statusMessage_88hr8_17"
};